import { classNames, useState } from 'libs/react';
import { ButtonStatus } from '../DealItemPicker';
import { Button } from 'components/Button';
import { React } from 'libs/react';
import './DealItemPickerDoneButton.scss';
/**
 * @component DealItemPickerNextButton
 * @since 1.0.0
 * @hidden
 */
export function DealItemPickerDoneButton(props) {
    const { style, label, status, onPress } = Object.assign({ label: t('Add to quote') }, props);
    const [processing, setProcessing] = useState(false);
    if (status == ButtonStatus.Hidden) {
        return null;
    }
    const className = classNames('deal-item-picker-done-button', 'deal-item-picker-done-button--' + style, props.className);
    const disabled = status == ButtonStatus.Disabled;
    const onPressButton = () => {
        setProcessing(true);
        onPress();
    };
    return (React.createElement("div", { className: "deal-item-picker-tool-bar-item" },
        React.createElement(Button, { className: className, style: "primary", badge: "arrow-right", label: label, disabled: disabled || processing, onPress: onPressButton, processing: processing })));
}
